type ValidationDetail = {
    loc?: unknown
    msg?: unknown
}

export function parseDriverValidationFieldErrors(body: unknown): Record<string, string> {
    if (body == null || typeof body !== 'object' || !('detail' in body)) {
        return {}
    }

    const detail = (body as {detail?: unknown}).detail
    if (!Array.isArray(detail)) {
        return {}
    }

    const fieldErrors: Record<string, string> = {}
    for (const item of detail) {
        if (item == null || typeof item !== 'object') {
            continue
        }
        const entry = item as ValidationDetail
        if (!Array.isArray(entry.loc) || typeof entry.msg !== 'string') {
            continue
        }
        const field = entry.loc.at(-1)
        if (typeof field === 'string') {
            fieldErrors[field] = entry.msg
        }
    }
    return fieldErrors
}
